import React, {Fragment} from 'react';
import {Box} from '@material-ui/core';
import {EfeAutocomplete} from 'components';
import {EfeCatalogValue} from 'commons/models';

function Select() {
    const options: Array<EfeCatalogValue> = [
        {value: 'Viajes y Gastos', id: '1', order: 1, status: 'A'},
        {value: 'Comida', id: '2', order: 2, status: 'A'},
        {value: 'Combustible', id: '3', order: 3, status: 'A'},
    ];
    const [value, setValue] = React.useState<EfeCatalogValue | null>(null);

    function handleInputChange(newValue: any) {
        setValue(newValue);
    }

    return (
        <Fragment>
            <Box pt={4}>
                <EfeAutocomplete
                    name='Label'
                    labelText='Label'
                    selectedValue={value}
                    options={options}
                    onValueChange={(value: any) => handleInputChange(value)}
                />
            </Box>
        </Fragment>
    );
}

export default Select;
